import React, { useState } from 'react';
import '../../styles/ChangePassword.css';
import { fetchSubscriptionForgotPasswordUserApi } from '../../api/api';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();


  const handleSubmit = async(e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email) {
      setError('Email field are required');
      return;
    }

    const response = await fetchSubscriptionForgotPasswordUserApi(email); 

    if (response.statuscode === 200) {
      setSuccess(response.message || 'Forgot password link send to your email.');
      setEmail('');
      setTimeout(() => navigate('/login'), 3000);
    } else if (response.statuscode === 404) {
      setError(response.message);
    } else {
      setError('Invalid email, password');
    }
    
  };

  return (
    <div className="change-password-container">
      <form className="change-password-form" onSubmit={handleSubmit}>
        <h2>Forgot Password</h2>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email"
            autoComplete="email"
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
